export const textLengthValidate = (t, { minLength = null, maxLength = null }) => ({
  ...(minLength !== null ? { minLength: (value) => value?.length >= minLength || t('The text length should be over {{minLength}}.', { minLength }) } : {}),
  ...(maxLength !== null
    ? {
        maxLength: (value) => value === null || value.length <= maxLength || t('The text length should be below {{maxLength}}', { maxLength }),
      }
    : {}),
});
